import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function getCustomToken(key) {
  return Cookies.get(key)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setCustomToken(key, token) {

  return Cookies.set(key, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js